<div class="group-container">
  <app-navigation-group *ngFor="let group of trigger.config.groups" [group]="group"></app-navigation-group>
</div>
